import React from 'react';
import { CHECKOUT_URL, PURCHASE_ANCHOR } from '../data/content';
interface CTAButtonProps {
  label: string;
  sub?: string;
  target?: 'purchase' | 'checkout';
  className?: string;
}
export function CTAButton({
  label,
  sub,
  target = 'purchase',
  className = ''
}: CTAButtonProps) {
  return <a href={target === 'checkout' ? CHECKOUT_URL : PURCHASE_ANCHOR} className={`block w-full rounded-md bg-teal px-3 py-3 text-center font-heading text-[0.84rem] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_5px_0_0_#065F69] transition-[background-color,transform,box-shadow] duration-150 ease-out hover:bg-teal-dark active:translate-y-[3px] active:shadow-[0_2px_0_0_#065F69] focus:outline-none focus-visible:ring-4 focus-visible:ring-teal/40 sm:text-lg ${className}`} data-id="element-29" data-mp="2fz21wopnf0wk">
      {label}
      {sub ? <span className="mt-0.5 block font-body text-[0.66rem] font-semibold normal-case tracking-normal text-white/85 sm:text-xs" data-id="element-30" data-mp="3cqdtak7q8j3e">
          {sub}
        </span> : null}
    </a>;
}